module.exports = __webpack_public_path__ + "img/FI19211852.12595a83.png";